import * as React from 'react';
import { connect } from 'react-redux';
import instadate from 'instadate';
import Modal from '../../common/modal';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import TimePointer from './calendar-day.time-pointer.js';
import TimeRow from './calendar-day.time-row.js';
import EventCells from './calendar-day.event-cells.js';
import EventMarking from './calendar-day.event-marking.js';
import EventModals from '../modals/calendar-day.event-modals.js';
import Select from '../../form/select.js';
import { selectReservedResources } from '../calendar.selectors.js';
import { formatDate, parseUrlParams } from '../calendar.model.js';
import { moveEvent } from '../calendar-day.actions.js';
import { chageRecurringOptions } from '../calendar.consts.js';

class CalendarGridMarkup extends React.Component {
  render() {
    const {
      data,
      UI,
      URL,
      timezone,
      filterSettings,
      accessgroups,
      draggedEvent,
      fieldAttrs,
      filterForm,
      handleHistoryChange,
      moveEvent,
      handleTimelineSettingsChange,
      handleCollapseToggleClick,
      handleInstructorClick,
      handleDaysGreedScroll,
      handleEndDragLeft,
      handleEndDragRight,
      handleEndMove,
      handleStartDrag,
      setGridRef,
      setActiveDayRef,
      detailed = true,
      passengersInfoFirst = false,
      handleCloseRecurrentMove,
      onEventClick
    } = this.props;

    const {
      resources,
      resourcesList,
      days,
      daysList,
      events,
      locationsSchedule,
      resourcesSchedule,
      instructorsAccessibility
    } = data;

    const reservedResources = selectReservedResources(data);

    return (
      <div>
        {detailed ? (
          <div className="scrolling-info">
            For horizontal scrolling, hold <b>Shift</b> key.
          </div>
        ) : null}
        <div className="calendar-day-wrapper">
          {detailed && parseUrlParams().action && (
            <EventModals handleHistoryChange={handleHistoryChange} />
          )}

          {detailed ? (
            <Modal
              cancelBackdropClick={true}
              isOpen={Boolean(UI.modals.MOVE_EVENT_RECURRENT)}
              onClose={handleCloseRecurrentMove}
              header="Move Recurring Event"
              footer={
                <button
                  className="btn btn-sm btn-success"
                  disabled={!draggedEvent.eventsForAction}
                  onClick={moveEvent}
                >
                  Move Event
                </button>
              }
            >
              <Select
                className="form-control input-sm"
                title="Select events"
                placeholder="Select events"
                label="Select which events will be affected"
                options={chageRecurringOptions}
                value={draggedEvent.eventsForAction || ''}
                name="draggedEvent.eventsForAction"
                {...fieldAttrs}
                required
              />
            </Modal>
          ) : null}

          <div className="calendar-day-left-panel">
            {detailed ? (
              <div className="timezones-view">
                <b>Timeline:</b>{' '}
                <label className="timezones-label">
                  <input
                    type="checkbox"
                    id="utc"
                    name="utc"
                    checked={filterSettings.utc === '1'}
                    onChange={handleTimelineSettingsChange}
                  />
                  <span className="timezones-title" title="UTC Zulu time">
                    UTC
                  </span>
                </label>
                <label className="timezones-label">
                  <input
                    type="checkbox"
                    id="filter"
                    name="filter"
                    checked={filterSettings.filter === '1'}
                    onChange={handleTimelineSettingsChange}
                  />
                  <span className="timezones-title" title={filterForm.timezone}>
                    Custom
                  </span>
                </label>
              </div>
            ) : resourcesList.length ? (
              <div className="calendar-grid-timezone-placeholder" />
            ) : null}
            <div className="calendar-day-time-description text-right">
              {filterSettings.utc === '1' ? (
                <div className="time-row-name">
                  <small>
                    <b>UTC Zulu time:</b>
                    {'  '}
                  </small>
                </div>
              ) : null}
              {filterSettings.filter === '1' ? (
                <div className="time-row-name">
                  <small>
                    <b>{filterForm.timezone}:</b>
                    {'  '}
                  </small>
                </div>
              ) : null}
            </div>

            <ul className="multilevel-list">
              {resourcesList.map((id, i) => {
                const resource = resources[id];
                const prevResource = resourcesList[i - 1] ? resources[resourcesList[i - 1]] : {};
                const isAirworthy = resource.statusInspections === 'airworthy';
                const isUnairworthy = resource.statusInspections === 'unairworthy';

                return (
                  <span key={id}>
                    {resource.organizationID !== prevResource.organizationID ? (
                      <span>
                        {Object.keys(prevResource).length ? (
                          <li className="multilevel-item multilevel-item--level-1 inactive" />
                        ) : null}
                        <li
                          data-name={`grid-ORG-${resource.organizationID}`}
                          className="multilevel-item multilevel-item--level-1 multilevel-item-clickable"
                          title="Left click to collapse the view"
                          onClick={handleCollapseToggleClick}
                        >
                          <span
                            className={`icon ${
                              UI.modals[`grid-ORG-${resource.organizationID}`]
                                ? 'circle-arrow-right'
                                : 'circle-arrow-down'
                            }`}
                          />{' '}
                          <span className="multilevel-item-link">
                            <b className="text-danger">{resource.organizationName}</b>
                          </span>
                        </li>
                      </span>
                    ) : null}

                    {resource.locationID !== prevResource.locationID ? (
                      !UI.modals[`grid-ORG-${resource.organizationID}`] ? (
                        <li
                          data-name={`grid-LOC-${resource.organizationID}-${resource.locationID}`}
                          className="multilevel-item multilevel-item--level-2 multilevel-item-clickable"
                          title="Left click to collapse the view"
                          onClick={handleCollapseToggleClick}
                        >
                          <span
                            className={`icon ${
                              UI.modals[
                                `grid-LOC-${resource.organizationID}-${resource.locationID}`
                              ]
                                ? 'circle-arrow-right'
                                : 'circle-arrow-down'
                            }`}
                          />{' '}
                          <span className="multilevel-item-link">
                            <b className="text-danger">
                              {resource.locationName} {resource.locationIATA}
                            </b>
                          </span>
                        </li>
                      ) : null
                    ) : null}

                    {resource.resourceTypeID !== prevResource.resourceTypeID ||
                    resource.organizationID != prevResource.organizationID ? (
                      !UI.modals[`grid-ORG-${resource.organizationID}`] &&
                      !UI.modals[`grid-LOC-${resource.organizationID}-${resource.locationID}`] ? (
                        <li
                          data-name={`grid-RES-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}`}
                          className="multilevel-item multilevel-item--level-3 multilevel-item-clickable"
                          title="Left click to collapse the view"
                          onClick={handleCollapseToggleClick}
                        >
                          <span
                            className={`icon ${
                              UI.modals[
                                `grid-RES-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}`
                              ]
                                ? 'circle-arrow-right'
                                : 'circle-arrow-down'
                            }`}
                          />{' '}
                          <span className="multilevel-item-link">
                            {`${resource.resourceTypeName}${
                              resource.resourceTypeName === 'Instructor' ||
                              resource.resourceTypeName === 'Simulator'
                                ? 's'
                                : ''
                            }`}
                          </span>
                        </li>
                      ) : null
                    ) : null}

                    {!UI.modals[`grid-ORG-${resource.organizationID}`] &&
                    !UI.modals[`grid-LOC-${resource.organizationID}-${resource.locationID}`] &&
                    !UI.modals[
                      `grid-RES-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}`
                    ] ? (
                      <li
                        data-name={`grid-RESERV-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}-${resource.resourceID}`}
                        data-instructor={resource.resourceID}
                        data-org-id={resource.organizationID}
                        data-location={resource.locationID}
                        className="multilevel-item multilevel-item--level-4 multilevel-item-clickable"
                        title={
                          resource.resourceTypeName === 'Aircraft'
                            ? isAirworthy
                              ? 'Airworthy'
                              : isUnairworthy
                              ? 'Unairworthy'
                              : ''
                            : ''
                        }
                        onClick={
                          reservedResources[id].maxLevel
                            ? handleCollapseToggleClick
                            : resource.resourceTypeName === 'Instructor'
                            ? handleInstructorClick
                            : null
                        }
                      >
                        {reservedResources[id].maxLevel ? (
                          <span>
                            <span
                              className={`icon ${
                                UI.modals[
                                  `grid-RESERV-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}-${resource.resourceID}`
                                ]
                                  ? 'circle-arrow-right'
                                  : 'circle-arrow-down'
                              }`}
                            />{' '}
                          </span>
                        ) : null}
                        {resource.resourceTypeName === 'Aircraft' ? (
                          <span
                            className={`pull-right inspections-status icon
                                    ${isAirworthy ? ' checkmark-circle text-success' : ''}
                                    ${isUnairworthy ? ' cancel-circled text-danger' : ''}
                                  `}
                          />
                        ) : null}
                        <span
                          className={`multilevel-item-link ${
                            reservedResources[id].maxLevel ? 'not-link' : ''
                          }`}
                        >
                          {(resource.aircraftID || resource.simulatorID) &&
                          accessgroups.resourceView ? (
                            <span>
                              <a
                                href={
                                  resource.aircraftID
                                    ? `${URL.org}/resources/#?model=craft&action=view&element=${resource.aircraftID}`
                                    : `${URL.org}/resources/#?model=simulator&action=view&element=${resource.simulatorID}`
                                }
                                target="_blank"
                                className="resource-link"
                              >
                                {resource.resourceName}
                              </a>
                              {resource.regNumb ? (
                                <span className="text-muted">
                                  {'  '}#{resource.regNumb}
                                </span>
                              ) : null}
                            </span>
                          ) : (
                            <span>{resource.resourceName}</span>
                          )}
                        </span>
                      </li>
                    ) : null}

                    {reservedResources[id].maxLevel
                      ? !UI.modals[`grid-ORG-${resource.organizationID}`] &&
                        !UI.modals[`grid-LOC-${resource.organizationID}-${resource.locationID}`] &&
                        !UI.modals[
                          `grid-RES-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}`
                        ] &&
                        !UI.modals[
                          `grid-RESERV-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}-${resource.resourceID}`
                        ]
                        ? Array.apply(null, { length: reservedResources[id].maxLevel }).map(
                            (_, i) => (
                              <li
                                key={`reservation-row-${i}`}
                                className="multilevel-item reservation multilevel-item--level-5"
                              >
                                <span className="multilevel-item-link not-link">Reservation</span>
                              </li>
                            )
                          )
                        : null
                      : null}
                  </span>
                );
              })}
            </ul>
          </div>

          <div
            className="calendar-day-container"
            onWheel={handleDaysGreedScroll}
            onMouseUp={
              draggedEvent.type
                ? draggedEvent.type === 'move-left'
                  ? handleEndDragLeft
                  : draggedEvent.type === 'move-right'
                  ? handleEndDragRight
                  : handleEndMove
                : null
            }
            onTouchEnd={
              draggedEvent.type
                ? draggedEvent.type === 'move-left'
                  ? handleEndDragLeft
                  : draggedEvent.type === 'move-right'
                  ? handleEndDragRight
                  : handleEndMove
                : null
            }
            onTouchCancel={
              draggedEvent.type
                ? draggedEvent.type === 'move-left'
                  ? handleEndDragLeft
                  : draggedEvent.type === 'move-right'
                  ? handleEndDragRight
                  : handleEndMove
                : null
            }
            ref={setGridRef}
          >
            <div className="calendar-day-container-content">
              <div className="calendar-day new-calendar-day">
                {parseInt(timezone.timeNow, 10) > parseInt(daysList[0], 10) &&
                parseInt(timezone.timeNow, 10) <
                  parseInt(daysList[daysList.length - 1], 10) + 24 * 3600 ? (
                  <TimePointer daysList={daysList} />
                ) : null}

                <div className="calendar-day-expand">
                  <div className="calendar-row calendar-row--clean">
                    {daysList.map(date => {
                      const day = days[date];
                      return (
                        <div
                          key={date}
                          ref={setActiveDayRef ? setActiveDayRef(date) : null}
                          className={`calendar-day-title
                              ${
                                parseInt(date, 10) === parseInt(timezone.dayTimestamp, 10)
                                  ? ' day-active'
                                  : instadate.isWeekendDate(
                                      instadate.resetTimezoneOffset(
                                        new Date(
                                          (parseInt(date, 10) + parseInt(timezone.offset, 10)) *
                                            1000
                                        )
                                      )
                                    )
                                  ? 'day-weekend'
                                  : ''
                              }
                              ${
                                instadate.isSameDay(
                                  instadate.resetTimezoneOffset(
                                    new Date(
                                      (parseInt(timezone.timeNow, 10) +
                                        parseInt(timezone.offset, 10)) *
                                        1000
                                    )
                                  ),
                                  instadate.resetTimezoneOffset(
                                    new Date(
                                      (parseInt(date, 10) + parseInt(timezone.offset, 10)) * 1000
                                    )
                                  )
                                )
                                  ? ' day-today'
                                  : ''
                              }
                            `}
                          style={{ width: `${Object.keys(day.timeSteps).length * 20}px` }}
                        >
                          <b>{formatDate(parseInt(date, 10), day.timezoneOffset, 'j M, l')}</b>
                        </div>
                      );
                    })}
                  </div>

                  <TimeRow
                    utc
                    show={filterSettings.utc === '1'}
                    locationsSchedule={locationsSchedule}
                    days={days}
                  />

                  <TimeRow
                    filter
                    show={filterSettings.filter === '1'}
                    locationsSchedule={locationsSchedule}
                    days={days}
                  />

                  {resourcesList.map((id, i) => {
                    const resource = resources[id];
                    const prevResource = resourcesList[i - 1]
                      ? resources[resourcesList[i - 1]]
                      : {};
                    return (
                      <div key={`grig-${id}`}>
                        {resource.organizationID !== prevResource.organizationID ? (
                          <span>
                            {Object.keys(prevResource).length ? (
                              <div className="calendar-row calendar-row-day-content inactive" />
                            ) : null}
                            <div className="calendar-row calendar-row-day-content text-center text-danger small center-name">
                              {resource.organizationName}
                            </div>
                          </span>
                        ) : null}

                        {resource.locationID !== prevResource.locationID ? (
                          !UI.modals[`grid-ORG-${resource.organizationID}`] ? (
                            <TimeRow
                              show
                              location={resource.locationID}
                              locationsSchedule={locationsSchedule}
                              days={days}
                            />
                          ) : null
                        ) : null}

                        {resource.resourceTypeID !== prevResource.resourceTypeID ||
                        resource.organizationID !== prevResource.organizationID ? (
                          !UI.modals[`grid-ORG-${resource.organizationID}`] &&
                          !UI.modals[
                            `grid-LOC-${resource.organizationID}-${resource.locationID}`
                          ] ? (
                            <div className="calendar-row calendar-row-day-content text-center small center-name">
                              {resource.resourceTypeName}
                            </div>
                          ) : null
                        ) : null}
                        {!UI.modals[`grid-ORG-${resource.organizationID}`] &&
                        !UI.modals[`grid-LOC-${resource.organizationID}-${resource.locationID}`] &&
                        !UI.modals[
                          `grid-RES-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}`
                        ] ? (
                          <div className="resources-with-one-type">
                            <div className="calendar-row">
                              <EventCells
                                resource={resource}
                                locationsSchedule={locationsSchedule}
                                resourcesSchedule={resourcesSchedule}
                                instructorsAccessibility={instructorsAccessibility}
                              />
                              <EventMarking
                                detailed={detailed}
                                passengersInfoFirst={passengersInfoFirst}
                                onClick={onEventClick}
                                resource={resource}
                                handleStartDrag={handleStartDrag}
                                daysList={daysList}
                                events={events}
                                resources={resources}
                                resourcesList={resourcesList}
                              />
                            </div>
                          </div>
                        ) : null}
                        {reservedResources[id].maxLevel
                          ? !UI.modals[`grid-ORG-${resource.organizationID}`] &&
                            !UI.modals[
                              `grid-LOC-${resource.organizationID}-${resource.locationID}`
                            ] &&
                            !UI.modals[
                              `grid-RES-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}`
                            ] &&
                            !UI.modals[
                              `grid-RESERV-${resource.organizationID}-${resource.locationID}-${resource.resourceTypeID}-${resource.resourceID}`
                            ]
                            ? Array.apply(null, { length: reservedResources[id].maxLevel }).map(
                                (_, i) => {
                                  return (
                                    <div key={`reservation-marking-${i}`} className="calendar-row">
                                      <EventCells
                                        resource={resource}
                                        reservation
                                        locationsSchedule={locationsSchedule}
                                        resourcesSchedule={resourcesSchedule}
                                        instructorsAccessibility={instructorsAccessibility}
                                      />
                                      <EventMarking
                                        detailed={detailed}
                                        passengersInfoFirst={passengersInfoFirst}
                                        onClick={onEventClick}
                                        handleStartDrag={handleStartDrag}
                                        resource={resource}
                                        level={i + 1}
                                        reservation
                                        daysList={daysList}
                                        events={events}
                                        resources={resources}
                                        resourcesList={resourcesList}
                                      />
                                    </div>
                                  );
                                }
                              )
                            : null
                          : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  UI: state.UI,
  URL: state.URL,
  timezone: state.timezone,
  timezones: state.timezones,
  filterSettings: state.filterSettings,
  filterForm: state.filterForm,
  accessgroups: state.accessgroups,
  draggedEvent: state.draggedEvent,
  scrollY: state.userUI.scrollY
});

export default connect(
  mapStateToProps,
  {
    moveEvent,
    ...formActions
  },
  mergeActionsToProps
)(CalendarGridMarkup);
